import styles from "./styles.module.css";

export default function ({ component, onSelect }) {
  return (
    <div onClick={() => onSelect(component)} className={styles.pageCardItem}>
      {component.name}
    </div>
  );
}
